import * as React from 'react';
import { Intent, Button } from '@blueprintjs/core';
import { LoadableSVG } from '../../LoadableSVG';
import { CoachingAudio } from '../../CoachingAudio';

interface Props {
    jouranlGraphic: string;
    coachingAudio: string;
    close: () => void;
};

interface State {
    hasAudioFinishedOnce: boolean;
}

export class GraphicView extends React.Component<Props, State> {

    state: State = {
        hasAudioFinishedOnce: false
    }

    renderGraphic = () => {
        return <span style={{flexGrow: 1, flexBasis: 0}}>
            <LoadableSVG imgURL={this.props.jouranlGraphic} />
        </span>
    }

    renderBlankJournal = () => {
        return <span style={{flexShrink: 1, transition: 'all 2s'}}></span>
    }

    renderOpenJournalButton = () => {
        return <Button large style={{display: 'block', width: '100%', marginTop: '10px'}} onClick={() => {
            this.props.close();
        }} intent={Intent.SUCCESS}>Done</Button>
    }

    renderAudioComponent = () => {
        return <CoachingAudio 
            audioSource={this.props.coachingAudio}
            donePlaying={() => {
                this.setState({
                    hasAudioFinishedOnce: true
                });
            }}
        />
    }

	render() {
        const graphic = this.renderGraphic();

        return <div className="journalParent" style={{ width: '100%'}}>
            {this.renderAudioComponent()}
            <span style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                {graphic}
                {this.renderBlankJournal()}
                {this.renderOpenJournalButton()}
            </span>
        </div>
    }
}
